// extracted by mini-css-extract-plugin
export default {"container":"categories_container__fdUTJ","category":"categories_category__y+qVN","category__title":"categories_category__title__qFUgb"};